module.exports = __webpack_public_path__ + "static/img/ba.c532672.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/logo/ba.jpg
// module id = Sq3b
// module chunks = 0